var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-loading",style:({
    backgroundColor: _vm.backgroundColor,
  })},[_c('div',{staticClass:"slogan"},[_c('div',{staticClass:"slogan-title"},[_vm._v(" "+_vm._s(_vm.slogan)+" ")])]),_c('img',{staticClass:"loading",attrs:{"src":require("@/assets/images/main_loading.gif")}})])}
var staticRenderFns = []

export { render, staticRenderFns }